import { render, staticRenderFns } from "./master-layout.vue?vue&type=template&id=30c32dd0&scoped=true&"
import script from "./master-layout.vue?vue&type=script&lang=js&"
export * from "./master-layout.vue?vue&type=script&lang=js&"
import style0 from "./master-layout.vue?vue&type=style&index=0&id=30c32dd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c32dd0",
  null
  
)

export default component.exports